import React from 'react'

export function SvgCheck({
  width = '18',
  height = '14',
  fill = '#0047BB',
  className,
}) {
  return (
    <svg
      {...{ width, height, fill, className }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m5.795 10.875-3.47-3.47a.996.996 0 1 0-1.41 1.41l4.18 4.18c.39.39 1.02.39 1.41 0l10.58-10.58a.996.996 0 1 0-1.41-1.41l-9.88 9.87Z" />
    </svg>
  )
}
